import { useMutation, useQuery, useQueryClient } from "react-query";
import streetLightAPI from "../../services/streetLightAPI";

import {  AxiosError } from "axios";
import { useSinglePole } from "..";
import { useEffect } from "react";
import { StreetLightPatch } from "../../types/streetLight.types";
import { CallbackFunction } from "./usePlanBTCore";


export interface SingleStreetLightConfig {
    streetLightId: string;
    planBTId: string;
}
export default function useSingleStreetLightCore({streetLightId, planBTId}: SingleStreetLightConfig) {

    const singleStreetLightQuery = useQuery({
        queryFn: () => streetLightAPI.getSingleStreetLight(streetLightId),
        enabled: streetLightId ? true : false,
        queryKey: ["singleStreetLight", streetLightId]
    })

    const { singlePoleQuery } = useSinglePole({
        planBTId: planBTId,
        poleId: singleStreetLightQuery.data?.str_light_pole
    })
    const queryClient = useQueryClient();

    const updateStreetLightMutation = useMutation({
        mutationFn: ({
          streetLight,
          callback,
        }: {
          streetLight: StreetLightPatch;
          callback?: CallbackFunction;
        }) =>
          streetLightAPI
            .updateStreetLight(streetLightId, streetLight)
            .then((res) => {
              callback && callback({ result: res });
              return Promise.resolve(res);
            })
            .catch((error) => {
              callback && callback({ error });
              return Promise.reject(error);
            }),
        onSettled: () => {
            queryClient.invalidateQueries("streetLights");
            queryClient.invalidateQueries(["singleStreetLight", streetLightId]);
        },
      });

    useEffect(() => {
        if(singleStreetLightQuery.data && singlePoleQuery.data?.pole_id){
            singlePoleQuery.refetch()
        }
    },[singleStreetLightQuery.data]) // eslint-disable-line
  return {

    singleStreetLightQuery: {
      ...singleStreetLightQuery,
      error: singleStreetLightQuery.error,
    },
    singlePoleQuery: {
      ...singlePoleQuery,
      error: singlePoleQuery.error as AxiosError,
    },
    updateStreetLightMutation: {
        ...updateStreetLightMutation,
        error: updateStreetLightMutation.error as AxiosError,
    }
}}
